import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
      <div className="max-w-3xl">
        <span className="inline-block rounded-full border border-[var(--color-border)] bg-[var(--color-bg-card)] px-3 py-1 text-xs font-medium text-[var(--color-text-secondary)]">
          KSS BillBook · Cloud GST Billing &amp; ERP
        </span>
        <h1 className="mt-4 text-4xl font-semibold tracking-tight sm:text-5xl">
          Bill faster. Account smarter. Run the whole business from one app.
        </h1>
        <p className="mt-4 text-base text-[var(--color-text-secondary)] sm:text-lg">
          GST-ready invoicing, inventory, POS, restaurant, purchase, accounting, payroll
          and reporting — on a single multi-tenant platform built for Indian SMBs.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/signup"
            className="inline-flex h-11 items-center rounded-md bg-[var(--color-primary)] px-5 text-sm font-medium text-white"
          >
            Start free trial
          </Link>
          <Link
            to="/panel"
            className="inline-flex h-11 items-center rounded-md border border-[var(--color-border)] px-5 text-sm"
          >
            Live demo
          </Link>
          <a
            href="#why-us"
            className="inline-flex h-11 items-center rounded-md px-5 text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]"
          >
            See features →
          </a>
        </div>
        <p className="mt-6 text-xs text-[var(--color-text-muted)]">
          Trusted by retailers, restaurants and distributors. e-Invoice, e-Way Bill, HSN/SAC,
          TDS and ITC reconciliation built in.
        </p>
      </div>
    </section>
  );
}
